import { render, staticRenderFns } from "./ProjectPanel.vue?vue&type=template&id=afbe1fc8&scoped=true"
import script from "./ProjectPanel.vue?vue&type=script&lang=js"
export * from "./ProjectPanel.vue?vue&type=script&lang=js"
import style0 from "./ProjectPanel.vue?vue&type=style&index=0&id=afbe1fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbe1fc8",
  null
  
)

export default component.exports